import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const MedicalIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 18 18"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="none"
    fill="currentColor"
  >
    <path
      d="M15.875 5.875H12.125V2.125C12.125 1.79348 11.9933 1.47554 11.7589 1.24112C11.5245 1.0067 11.2065 0.875 10.875 0.875H7.125C6.79348 0.875 6.47554 1.0067 6.24112 1.24112C6.0067 1.47554 5.875 1.79348 5.875 2.125V5.875H2.125C1.79348 5.875 1.47554 6.0067 1.24112 6.24112C1.0067 6.47554 0.875 6.79348 0.875 7.125V10.875C0.875 11.2065 1.0067 11.5245 1.24112 11.7589C1.47554 11.9933 1.79348 12.125 2.125 12.125H5.875V15.875C5.875 16.2065 6.0067 16.5245 6.24112 16.7589C6.47554 16.9933 6.79348 17.125 7.125 17.125H10.875C11.2065 17.125 11.5245 16.9933 11.7589 16.7589C11.9933 16.5245 12.125 16.2065 12.125 15.875V12.125H15.875C16.2065 12.125 16.5245 11.9933 16.7589 11.7589C16.9933 11.5245 17.125 11.2065 17.125 10.875V7.125C17.125 6.79348 16.9933 6.47554 16.7589 6.24112C16.5245 6.0067 16.2065 5.875 15.875 5.875ZM15.875 10.875H11.5C11.3342 10.875 11.1753 10.9408 11.0581 11.0581C10.9408 11.1753 10.875 11.3342 10.875 11.5V15.875H7.125V11.5C7.125 11.3342 7.05915 11.1753 6.94194 11.0581C6.82473 10.9408 6.66576 10.875 6.5 10.875H2.125V7.125H6.5C6.66576 7.125 6.82473 7.05915 6.94194 6.94194C7.05915 6.82473 7.125 6.66576 7.125 6.5V2.125H10.875V6.5C10.875 6.66576 10.9408 6.82473 11.0581 6.94194C11.1753 7.05915 11.3342 7.125 11.5 7.125H15.875V10.875Z"
      stroke="none"
      fill="currentColor"
    />
  </SvgIcon>
);

export default MedicalIcon;
